import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="w-full bg-surface px-4 py-20 text-ink sm:py-24" data-id="element-80" data-mp="3uei1jdqmbm1a">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="c7k4vvuvkjnt">
        <h2 className="font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-6xl" data-id="element-82" data-mp="85fd72nzlx3t">
          Your Step Classes.
          <br data-id="element-83" data-mp="m3nibxv6g4q2" />
          <span className="text-green-dark" data-id="element-84" data-mp="m3dr66yebris">Ready in 5 Minutes.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-85" data-mp="h52gxv46vf01">
          Join hundreds of professional step instructors who have stopped improvising and started teaching with a
          complete, structured, printable system.
        </p>
        <div className="mt-10" data-id="element-86" data-mp="14uwru74y6thn">
          <Countdown dark={false} data-id="element-87" data-mp="14w7wsaa4q7ac" />
        </div>
        <div className="mt-10" data-id="element-88" data-mp="zwd7gb605pre">
          <CTAButton size="large" data-id="element-89" data-mp="zxegyb7de470">🚀 Get Instant Access — $19 USD</CTAButton>
        </div>
        <p className="mt-5 text-xs leading-6 text-slate sm:text-sm" data-id="element-90" data-mp="2c5g5o456wyuw">
          🔒 Secure Payment · ⚡ Instant Access · 🛡️ 7-Day Guarantee · 💳 Card · ♾️ Lifetime Access
        </p>
      </Reveal>
    </section>;
}